import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import get from 'lodash/get'
import cloneDeep from 'lodash/cloneDeep'
import DatePicker from 'react-datepicker'
import { Button } from 'reactstrap'
import CustomButtonDate from '../../helpers/custom-datepicker'
import "../../../../static/css/index.css"
import { FONTS } from '../../../../constants'
import moment from '../../../../lib/moment.js'

export const MyTimesheetButton = class extends React.Component {
  render() {
    const { isEdit, myTimesheet, submitMyTimesheet, fillHours, weekdates } = this.props
    const { handleDate, handleDiscard } = this.props
    const selectedDate = cloneDeep(get(this.props, 'selectedDate'))
    const can_submit = get(myTimesheet, 'can_submit')
    const can_edit = get(myTimesheet, 'can_edit')
    const startWeek = get(weekdates, '0') ? `${get(weekdates, '0').format('DD')} ${get(weekdates, '0').format('MMM')}` : ''
    const endWeek = get(weekdates, `${weekdates.length - 1}`) ? `${get(weekdates, `${weekdates.length - 1}`).format('DD')} ${get(weekdates, `${weekdates.length - 1}`).format('MMM')}` : ''
    const hiring_date = get(this.props, 'authData.user.hiring_date')
    const last_effective_date = get(this.props, 'authData.user.last_effective_date')
    const isBeforeHiringDate = moment(selectedDate).isBefore(hiring_date, 'months')
    const isAfterLastEffectiveDate = moment(selectedDate).isAfter(last_effective_date, 'months')

    return (
      <Buttons>
        <DateGroup>
          <NavBarButtonToday
            background='white'
            color='black'
            onClick={ () => {
              if (isEdit) handleDiscard('clickMonth', moment())
              else handleDate(moment())
            } }
          >
          Today
          </NavBarButtonToday>
          <ArrowButton
            background='white'
            onClick={ () => {
              if (isEdit) handleDiscard('clickMonth', moment(selectedDate.add(-1, 'month')))
              else handleDate(moment(selectedDate.add(-1, 'month')))
            } }
          >&#65308;</ArrowButton>
          <LabelMonth>{ selectedDate.format('MMM') } { selectedDate.format('YYYY') }</LabelMonth>
          <ArrowButton
            background='white'
            onClick={ () => {
              if (isEdit) handleDiscard('clickMonth', moment(selectedDate.add(1, 'month')))
              else handleDate(moment(selectedDate.add(1, 'month')))
            } }
          >&#65310;</ArrowButton>
        </DateGroup>
        {/* timesheet mobile */}
        <DateGroupMobile>
          <ArrowButton
            background='white'
            onClick={ () => {
              if (isEdit) {
                const nextMonday = moment(selectedDate).clone().add(-1, 'week').day(1)
                const curMonday = moment(selectedDate).clone().day(1)
                if (nextMonday.format('MM') !== curMonday.format('MM')
                && (parseInt(moment(selectedDate).format('DD'), 10) < 10)) {
                  handleDiscard('clickMonth', moment(selectedDate.startOf('month')))
                } else if ((parseInt(moment(selectedDate).format('DD'), 10) === 1)) {
                  handleDiscard('clickMonth', moment(selectedDate.add(-1, 'month').endOf('month')))
                } else {
                  handleDiscard('clickMonth', moment(selectedDate.add(-1, 'week')).day(1))
                }
              } else {
                const nextMonday = moment(selectedDate).clone().add(-1, 'week').day(1)
                const curMonday = moment(selectedDate).clone().day(1)
                if (nextMonday.format('MM') !== curMonday.format('MM')
                && (parseInt(moment(selectedDate).format('DD'), 10) < 10)) {
                  handleDate(moment(selectedDate.startOf('month')))
                } else if ((parseInt(moment(selectedDate).format('DD'), 10) === 1)) {
                  handleDate(moment(selectedDate.add(-1, 'month').endOf('month')))
                } else {
                  handleDate(moment(selectedDate.add(-1, 'week')).day(1))
                }
              }
            } }
          >&#65308;</ArrowButton>
          <LabelMonth>
            { startWeek }  - { endWeek }
          </LabelMonth>
          <ArrowButton
            background='white'
            onClick={ () => {
              if (isEdit) {
                const nextMonday = moment(selectedDate).clone().add(1, 'week').day(1)
                const curMonday = moment(selectedDate).clone().day(1)
                if (nextMonday.format('MM') !== curMonday.format('MM')
                && (parseInt(moment(selectedDate).format('DD'), 10) > 20)) {
                  handleDiscard('clickMonth', moment(selectedDate.add(1, 'month').startOf('month')))
                } else {
                  handleDiscard('clickMonth', moment(selectedDate.add(1, 'week')).day(1))
                }
              } else {
                const nextMonday = moment(selectedDate).clone().add(1, 'week').day(1)
                const curMonday = moment(selectedDate).clone().day(1)
                if (nextMonday.format('MM') !== curMonday.format('MM')
                && (parseInt(moment(selectedDate).format('DD'), 10) > 20)) {
                  handleDate(moment(selectedDate.add(1, 'month').startOf('month')))
                } else {
                  handleDate(moment(selectedDate.add(1, 'week')).day(1))
                }
              }
            } }
          >&#65310;</ArrowButton>
          <CustomDatePicker
            customInput={ <CustomButtonDate /> }
            onChange={ (e) => {
              if (isEdit) handleDiscard('clickMonth', e)
              else handleDate(e)
            } }
            placeholderText='DD/MM/YYYY'
            selected={ get(this.props, 'selectedDate') }
            dateFormat="DD/MM/YYYY"
            popperPlacement="bottom-end"
            showYearDropdown
            showMonthDropdown
            dropdownMode="select"
          />
        </DateGroupMobile>
        {/* timesheet mobile */}
        { !this.props.isEdit &&
          <ButtonContainer>
            <NavBarButton
              background='#5CB85C'
              color='white'
              disabled={ !can_edit || isBeforeHiringDate || isAfterLastEffectiveDate }
              onClick={ () => this.props.clickEdit() }
            >
            Edit
            </NavBarButton>
            <NavBarButton
              background='#5CB85C'
              color='white'
              disabled={ !can_submit || isBeforeHiringDate || isAfterLastEffectiveDate }
              onClick={ () => submitMyTimesheet() }
            >Submit</NavBarButton>
          </ButtonContainer>
        }
        { this.props.isEdit &&
          <ButtonContainer>
            <NavBarButton
              background='#F1F1F1'
              color='#333333'
              onClick={ () => handleDiscard('clickCancel') }
            >
            Cancel
            </NavBarButton>
            <NavBarButton
              background='#5CB85C'
              color='white'
              onClick={ () => this.props.saveMyTimesheet() }
            >Save
            </NavBarButton>
            <FillAddButton onClick={ () => fillHours() }>Fill Hours</FillAddButton>
            <CopyButton onClick={ () => this.props.copyTimesheet() }>Copy Timesheet</CopyButton>
            <FillAddButton onClick={ () => this.props.addProject() }>Add Project</FillAddButton>
          </ButtonContainer>
        }
        {/* timesheet mobile */}
        { this.props.isEdit &&
        <ButtonDiv>
          <AddProjectMobileButton onClick={ () => this.props.addProject() }>
            Add<br />Project
          </AddProjectMobileButton>
        </ButtonDiv>
        }
        { !this.props.isEdit &&
        <ButtonDiv>
          <FillAddMobileButton
            disabled={ !can_submit }
            onClick={ () => submitMyTimesheet() }
          >
            Submit
          </FillAddMobileButton>
        </ButtonDiv>
        }
        {/* timesheet mobile */}
      </Buttons>
    )
  }
}

MyTimesheetButton.propTypes = {
  clickEdit: PropTypes.func.isRequired,
  handleDiscard: PropTypes.func.isRequired,
  handleDate: PropTypes.func.isRequired,
  submitMyTimesheet: PropTypes.func.isRequired,
  saveMyTimesheet: PropTypes.func.isRequired,
  copyTimesheet: PropTypes.func.isRequired,
  addProject: PropTypes.func.isRequired,
  fillHours: PropTypes.func.isRequired,
  isEdit: PropTypes.bool.isRequired,
  myTimesheet: PropTypes.object,
  weekdates: PropTypes.array,
}
MyTimesheetButton.defaultProps = {
  myTimesheet: {},
  weekdates: [],
}

const Buttons = styled.div`
  position: absolute;
  display: flex;
  right: 10px;
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.SMALL_SIZE};
  padding: 0.5rem 0.3rem !important;
  @media (max-width: 767.98px) {
    display:flex ;
    justify-content:flex-start;
    left: 10px;
    padding: 0rem 0.3rem !important;
  }
  @media (max-width: 575.98px) {
    display:flex ;
    justify-content:flex-start;
    left: 10px;
    padding: 0rem 0.3rem !important;
  }
`
const ButtonDiv = styled.div`
  @media (max-width: 1199.98px) {
    display: none;
  }
  @media (max-width: 991.98px) {
    display: none;
  }
  @media (max-width: 575.98px) {
    display: flex;
    justify-content: flex-end ;
  }
  @media (max-width: 767.98px) {
    display: flex;
    justify-content: flex-end ;
  }
  @media (min-width: 1200px) {
    display: none;
  }
`
const DateGroup = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  @media (max-width: 575.98px) {
    display: none;
  }
  @media (max-width: 767.98px) {
    display: none;
  }
`
const DateGroupMobile = styled.div`
  .react-datepicker-popper {
      z-index: 3;
  }
  @media (max-width: 1199.98px) {
    display: none;
  }
  @media (max-width: 991.98px) {
    display: none;
  }
  @media (max-width: 575.98px) {
    height: 50%;
    width: 80%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
  }
  @media (max-width: 767.98px) {
    height: 50%;
    width: 80%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
  }
  @media (min-width: 1200px) {
    display: none;
  }
`
const ButtonContainer = styled.div`
  @media (max-width: 575.98px) {
    display: none;
  }
  @media (max-width: 767.98px) {
    display: none;
  }
`
const NavBarButton = styled(Button)`
  height: 30px;
  width: 70px;
  font-size: 12px;
  margin-left: 5px;
  margin-right: 5px;
  text-align: center;
  background: ${(props) => { return props.background }};
  color: ${(props) => { return props.color }};
  border: 1px solid #E6E6E6;
  @media (max-width: 575.98px) {
    display: none;
  }
  @media (max-width: 767.98px) {
    display: none;
  }
`
const NavBarButtonToday = styled(Button)`
  height: 30px;
  width: 70px;
  font-size: 12px;
  margin-left: 5px;
  margin-right: 5px;
  text-align: center;
  background: ${(props) => { return props.background }};
  color: ${(props) => { return props.color }};
  border: 1px solid #E6E6E6;
  @media (max-width: 575.98px) {
    display: none;
  }
  @media (max-width: 767.98px) {
    display: none;
  }
`
const CustomDatePicker = styled(DatePicker)`
  height: 30px;
  width: 80px;
  font-size: 10px;
  margin-left: 5px;
  margin-right: 5px;
  text-align: center;
  border-radius: 5px;
  .react-datepicker-popper {
  z-index: 9999;
}
`
const FillAddButton = styled(Button)`
  height: 30px;
  width: 100px;
  font-size: 12px;
  margin-left: 5px;
  margin-right: 5px;
  text-align: center;
  background: #D44B49;
  color: white;
  border: 1px solid #E6E6E6;
`
const FillAddMobileButton = styled(Button)`
  height: 30px;
  width: 60px;
  font-size: 12px;
  text-align: right;
  background: #D44B49;
  color: white;
  border: none;
  &:hover{
    background: #D44B49;
    border: none;
  }
  &:disabled{
    background: #D44B49;
    border: none;
  }
  @media (min-width: 768px) {
    display:none;
  }
  @media (min-width: 992px) {
      display:none;
  }
  @media (min-width: 1200px) {
    display:none;
  }
`
const AddProjectMobileButton = styled(FillAddMobileButton)`
  padding: 0px 0px 0px 12px!important;
  text-align: center !important;
`
const CopyButton = styled(FillAddButton)`
  width: 125px;
`
const ArrowButton = styled(Button)`
  height: 30px;
  margin-left: 5px;
  margin-right: 5px;
  text-align: center;
  background: ${(props) => { return props.background }};
  width: 15%;
  color: black;
  font-size: 12px;
  border: 1px solid #E6E6E6;
  @media (max-width: 575.98px) {
    border: none;
    color: white;
    background: #D44B49;
    margin-left: 0px;
    padding: 0px !important;
  }
  @media (max-width: 767.98px) {
    border: none;
    color: white;
    background: #D44B49;
    margin-left: 0px;
    padding: 0px !important;
  }
`
const LabelMonth = styled.label`
  width: 70px;
  font-size: ${FONTS.SMALL_SIZE};
  margin-top: 2%;
  text-align: center;
  font-family: ${FONTS.GOTHAM_MEDIUM};
  @media (max-width: 575.98px) {
    width: 120px;
    margin-bottom: 0px !important;
    font-size: 12px !important;
    color: white;
    margin-left: 0px!important;
  }
  @media (max-width: 767.98px) {
    width: 120px;
    margin-bottom: 0px !important;
    font-size: 12px !important;
    color: white;
    margin-left: 0px!important;
  }
`



// WEBPACK FOOTER //
// ./src/components/timesheet/tab/button-group/my-timesheet-button.js